import React, { FC, useRef, useState, useLayoutEffect, useEffect } from 'react';

import { Container } from '@crehana/ui';

import { LiveCategories, LiveCategory } from 'Jsx/CrehanaLive/types';

import LiveList from '../LiveList';

import Categories from './Categories';

interface CategoriesAndLiveListProps {
  liveCategories: LiveCategories;
}

const CategoriesAndLiveList: FC<CategoriesAndLiveListProps> = ({
  liveCategories,
}) => {
  const liveListRef = useRef<HTMLDivElement | null>(null);
  const [categorySelected, setCategorySelected] = useState<LiveCategory>();

  useLayoutEffect(() => {
    if (window.location.href.includes('#')) {
      const [, category] = window.location.href.split('#');
      const exists = liveCategories.find(cat => cat.slug === category);

      if (exists) {
        setCategorySelected(exists);
      }
    }
  }, []);

  useEffect(() => {
    if (categorySelected?.id && liveListRef.current) {
      // Prevent the browser (chrome) from restoring its previous scroll location
      if ('scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'manual';
      }
      liveListRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  }, [categorySelected?.id]);

  return (
    // This is used to scroll to this secction
    <Container className="categories-and-lives">
      <Categories
        categorySelected={categorySelected}
        liveCategories={liveCategories}
        setCategorySelected={setCategorySelected}
      />
      <div ref={liveListRef} className="pt-72">
        <LiveList
          categorySelected={categorySelected}
          setCategorySelected={setCategorySelected}
        />
      </div>
    </Container>
  );
};

export default CategoriesAndLiveList;
